import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { Button, Icon, Modal } from 'semantic-ui-react';
import useStorage from '../../../../hooks/use-storage';
import { BusinessPropType } from '../../../../services/proptypes';
import { DOMAIN_STORAGE_KEY, DOMAIN_TYPE_STORAGE_KEY, CHECKOUT_STEP_STORAGE_KEY } from './DaySmartPublishModal.constants';
import { DomainContext } from './DaySmartPublishModal.context';
import { prefixLocalStorageKey } from './DaySmartPublishModal.utils';
import CheckoutConfirmation from './components/CheckoutConfirmation';
import DomainSelect from './components/DomainSelect';
var defaultProps = {
  open: false
};
export default function DaySmartPublishModal(_ref) {
  var business = _ref.business,
      open = _ref.open,
      onOpen = _ref.onOpen,
      onClose = _ref.onClose,
      defaultDomain = _ref.defaultDomain;
  var id = business.id;

  var _useStorage = useStorage(prefixLocalStorageKey(id, DOMAIN_STORAGE_KEY), defaultDomain),
      _useStorage2 = _slicedToArray(_useStorage, 2),
      domain = _useStorage2[0],
      setDomain = _useStorage2[1];

  var _useStorage3 = useStorage(prefixLocalStorageKey(id, DOMAIN_TYPE_STORAGE_KEY), null),
      _useStorage4 = _slicedToArray(_useStorage3, 2),
      domainType = _useStorage4[0],
      setDomainType = _useStorage4[1];

  var _useStorage5 = useStorage(prefixLocalStorageKey(id, CHECKOUT_STEP_STORAGE_KEY), 0),
      _useStorage6 = _slicedToArray(_useStorage5, 2),
      step = _useStorage6[0],
      setStep = _useStorage6[1];

  function resetStorage() {
    setDomain(defaultDomain);
    setDomainType(null);
    setStep(0);
  }

  function onNext() {
    setStep(step + 1);
  }

  function onBack() {
    setStep(step - 1 < 0 ? 0 : step - 1);
  }

  var domainContextInitialValue = {
    domain: domain,
    domainType: domainType,
    setDomain: setDomain,
    setDomainType: setDomainType
  };
  return /*#__PURE__*/React.createElement(Modal, {
    trigger: /*#__PURE__*/React.createElement(Button, {
      id: "publish-now-button",
      className: "payment-publish-button"
    }, "Select Domain"),
    dimmer: "inverted",
    open: open,
    onOpen: onOpen,
    onClose: onClose,
    className: "modal-container"
  }, /*#__PURE__*/React.createElement(Button, {
    id: "inside-close-icon",
    className: "inside-close-icon",
    onClick: onClose,
    icon: true
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "close"
  })), /*#__PURE__*/React.createElement(Modal.Content, {
    className: "modal-body"
  }, /*#__PURE__*/React.createElement(DomainContext.Provider, {
    value: domainContextInitialValue
  }, step === 0 && /*#__PURE__*/React.createElement(DomainSelect, {
    business: business,
    onComplete: onNext,
    onFailure: resetStorage,
    domainSeedValue: defaultDomain
  }), step === 1 && /*#__PURE__*/React.createElement(CheckoutConfirmation, {
    onBack: onBack
  }))));
}
DaySmartPublishModal.defaultProps = defaultProps;